<template>
  <modal v-ref:modal :is-shown.sync="isShown" size="sm" class="goal-modal">
  <div slot="content">
    <div class="modal-header">
      <span>今月の目標</span>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th></th>
            <th>目標</th>
            <th>実績</th>
            <th>差分</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="apiResult.current">
            <td>昨夜時点</td>
            <td>{{ apiResult.current.goalNumber }}</td>
            <td>{{ apiResult.current.reservationCount }}</td>
            <td><span v-bind:class="resultNumClass(apiResult.current.result)">{{ apiResult.current.result }}</span></td>
          </tr>
          <tr v-if="apiResult.summary">
            <td>月間状況</td>
            <td>{{ apiResult.summary.goalNumber }}</td>
            <td>{{ apiResult.summary.reservationCount }}</td>
            <td><span v-bind:class="resultNumClass(apiResult.summary.result)">{{ apiResult.summary.result }}</span></td>
          </tr>
          <tr>
            <td colspan="4"></td>
          </tr>
          <tr v-for="row in rows" v-bind:class="rowClass(row)">
            <td>{{ printDate(row.date) }}</td>
            <td>{{ row.goalNumber }}</td>
            <td>{{ row.reservationCount }}</td>
            <td><span v-bind:class="resultNumClass(row.result)">{{ row.result }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </modal>
</template>

<script>
import moment from 'moment'

export default {
  name: 'goal-modal',
  props: {
    apiResult: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isShown: false,
    }
  },
  computed: {
    rows () {
      return this.apiResult.rows
    },
  },
  methods: {
    show () {
      this.isShown = true
    },
    printDate (date) {
      let tmp = moment(date)
      return tmp.locale('ja').format('D日 (ddd)')
    },
    rowClass (row) {
      let year = this.$route.params.year
      let month = this.$route.params.month
      let day = this.$route.params.day
      let today = moment(`${year}-${month}-${day}`)
      if (today.isSame(row.date)) {
        return 'today'
      }
    },
    resultNumClass (result) {
      if (result > 0) {
        return 'plus'
      } else if (result < 0) {
        return 'minus'
      }
    }
  },
  components: {
    modal: require('ui/modal.vue'),
  },
}
</script>

<style scoped>
.today {
  background-color: #F2F5A9 !important;
}
</style>

<style>
.goal-modal > .modal-dialog {
  width: 50%;
  max-width: 1000px;
}
</style>



// WEBPACK FOOTER //
// goal.vue?6aece81e